<template>
    <pre class="tabs">
<b>Tuning: EADGBe (Standard Tuning)

h hammer-on
p pull-off
x mute note

TAB:</b>

INTRO
Variation 1

e|----------0---0---0--|
B|------2---3---2---2--|
G|------------------2--|
D|----2---2---------2--|
A|--0-------0-0---0-0--|
E|---------------------|

VERSE
Variation 1

e|--------------------------------0------------------------------|
B|------2----------------------------------3--------2------------|
G|--------2-----4--------2----------1----2---2----2---2------1h2-|
D|----2-------2---2----2---2----2--------------------------2-----|
A|--0----------------------------------2--------0----------------|
E|----------4--------2--------0--------------------------0-------|

e|-----0----|
B|----------|
G|1---------|
D|---2---2--|
A|----------|
E|--0-------|

Variation 2

e|--------------------------------0---------------------x--------|
B|------2----------------------------------3--------2---x-0-00-0-|
G|--------2-----4--------2----------1----2---2----2---2-x-1-11h2-|
D|----2-------2---2----2---2----2-----------------------x-2-22-2-|
A|--0----------------------------------2--------0-------x-2-22-2-|
E|----------4--------2--------0-------------------------x-0-00-0-|

e|-----0----|
B|-0--------|
G|-1--------|
D|-2-2---2--|
A|-2-2------|
E|-0-0------|

Variation 3

e|--------------------------------0----------------------x-------|
B|------2----------------------------------3--------2----x-0-00-0|
G|--------2-----4--------2----------1----2---2----2---2--x-1-11h2|
D|----2-------2---2----2---2----2------------------------x-2-22-2|
A|--0----------------------------------2--------0--------x-2-22-2|
E|----------4--------2--------0--------------------------x-0-00-0|

e|-----0----|
B|-0---0----|
G|-1---x----|
D|-2-2---2--|
A|-2-2---2--|
E|-0-0---0--|

Variation 4

e|--------------------------------0---------------------x--------|
B|------2----------------------------------3--------2---x-0-00-0-|
G|--------2-----4--------2----------1----2---2----2---2-x-1-11h2-|
D|----2-------2---2----2---2----2-----------------------x-2-22-2-|
A|--0----------------------------------2--------0-------x-2-22-2-|
E|----------4--------2--------0-------------------------x-0-00-0-|

e|-----0----|
B|-0---0----|
G|-1---x----|
D|-2-2---2--|
A|-2-2---2--|
E|-0-0---0--|

PRE-CHORUS
Variation 1

e|--------------------------------------------0--0---------------|
B|----------------2-222h3-2--2------3-------2----3---------------|
G|-----2-------4--2-222-2-2--2----2---2----------2---------------|
D|---2---2---2----2-222-2-2--2-------------------0---------------|
A|----------------0-000-0----0--2---------4----------------------|
E|-2-------4-----------------------------------------------------|

CHORUS
Variation 1

e|--------------------------------0---------------------x--------|
B|------2----------------2-----------------3--------2---x-0-00-3-|
G|--------2-----4------2---2--------1----2---2----2---2-x-1-11-2-|
D|----2-------2---2------------2------------------------x-2-22-0-|
A|--0----------------------------------2--------0-------x-2-22---|
E|----------4--------2--------0-------------------------x-0-00---|

e|----|
B|33--|
G|22--|
D|00--|
A|----|
E|----|

Variation 2

e|--------------------------------------------------0------------|
B|------2----------------0-------2---------3------------0-00-0-0-|
G|--------2-----4------0---0---2---2-----2---2----2---2-1-11h2-1-|
D|----2-------2---2-------------------------------------2-22-2-2-|
A|--0----------------------------------2--------4-------2-22-2-2-|
E|----------4--------3--------2-------------------------0-00-0-0-|

BREAK
Variation 1

e|--------------------------------0------------0---0---0-|
B|------2----------------------------------2---3---2---2-|
G|--------2-----4--------2----------1------------------2-|
D|----2-------2---2----2---2----2--------2---2---------2-|
A|--0----------------------------------0-------0-0---0-0-|
E|----------4--------2--------0--------------------------|

Variation 2

e|----------0---0---0--|
B|------2---3---2---2--|
G|------------------2--|
D|----2---2---------2--|
A|--0-------0-0---0-0--|
E|---------------------|

Variation 3

e|--------------------------------0------------------------------|
B|------2----------------2--------------------------3--2---------|
G|--------2-----4------2---2--------1------7--------2--2---------|
D|----2-------2---2------------2---------7---7----4----2---------|
A|--0----------------------------------5--------2------0---------|
E|----------4--------2--------0----------------------------------|

BRIDGE
Variation 1

e|--------x-------------x----x---------xx-----xx-----x-0---------|
B|--------x-------------x----x---------xx-3-3-xx-5-5-x-3---------|
G|--4-4-4-x-4-44-4-44-4-x3-3-x-33-3333-xx-2-2-xx-4-4-x-2---------|
D|--5-5-5-x-5-55-5-55-5-x4-4-x-44-4444-xx-4-4-xx-6-6-x-0---------|
A|--5-5-5-x-5-55-5-55-5-x4-4-x-44-4444-xx-2-2-xx-4-4-x-----------|
E|--3-3-3-x-3-33-3-33-3-x2-2-x-22-2222-xx-----xx-----x-----------|

<b>SEQUENCE:</b>

INTRO
Variation 1

VERSE 1
Variation 1, Variation 2

PRE-CHORUS
Variation 1

CHORUS 1
Variation 1, Variation 2

BREAK 1
Variation 1

VERSE 2
Variation 3, Variation 4

PRE-CHORUS
Variation 1

CHORUS 2
Variation 1, Variation 2

BREAK 2
Variation 2

BRIDGE
Variation 1

CHORUS 3
Variation 1, Variation 2

BREAK 3
Variation 3

Tab Written By: D. WATERMELONE
    </pre>
</template>
<script>
export default {
    name: 'FixingABrokenHeart'
}
</script>
